import { FileSize } from '../constant/file-size';
import NoPropertyPhoto from '../images/no_property_photo.png'

const getOdysseyImage = (imageId) => {
    return imageId ? `${process.env.REACT_APP_API_ENDPOINT}/api/v1/files/${imageId}` : NoPropertyPhoto;
}
const getOdysseyFile = (fileId,isAProperty) => {
    let baseUrl = isAProperty ? process.env.REACT_APP_PROPERTY_API_ENDPOINT : process.env.REACT_APP_API_ENDPOINT
    return fileId ? `${baseUrl}/api/v1/files/${fileId}` : (isAProperty ? NoPropertyPhoto : '');
}

const newsSectionImage = (imageId) => {
    return imageId ? `${process.env.REACT_APP_API_ENDPOINT}/api/v1/files/${imageId}` : null;
}

const getPropertyImage = (imageId, fileSize = FileSize.Original) => {
    return imageId ? `${process.env.REACT_APP_PROPERTY_API_ENDPOINT}/api/v1/files/images/${imageId}?fileSize=${fileSize}` : NoPropertyPhoto;
}

const getPrimaryPropertyImage = (propertyId, fileSize = FileSize.Original) => {
    return propertyId ? `${process.env.REACT_APP_PROPERTY_API_ENDPOINT}/api/v1/files/main-property-image/${propertyId}?fileSize=${fileSize}` : NoPropertyPhoto;
}

export { newsSectionImage, getOdysseyImage, getOdysseyFile, getPropertyImage, getPrimaryPropertyImage }